import React from 'react';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { ReactComponent as DeleteIcon } from 'new/components/icons/fi-rr-trash.svg';
import Menu from 'js/components/elements/menu/Menu';
import { Nexset } from 'new/entities/Nexset';
import { removeDomainItem } from 'js/actions';
import { showAlert } from 'new/stores/showAlert/action';

interface DomainItemDetailActionProps {
  item: Nexset;
  domainId: number;
  onCloseDrawer: () => void;
}

const DomainItemDetailAction = (props: DomainItemDetailActionProps) => {
  const { item, domainId, onCloseDrawer } = props;
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();

  const onClickDelistDomainItem = (item) => {
    dispatch(removeDomainItem(domainId, item?.id)).then(() => {
      dispatch(
        showAlert({
          title: `Data Product "${item.name}" deleted`,
          severity: 'success',
        }),
      );
    });
    onCloseDrawer();
  };

  const menuItems = [
    {
      key: `delist-${item.id}`,
      type: 'dialog',
      label: 'Delist Data Product',
      icon: <DeleteIcon />,
      color: 'error',
      dialogMessage: `Please confirm you want to delist: ${item.name} (Nexset ID: ${item.id})`,
      discardLabel: 'Cancel',
      confirmLabel: 'Delist',
      onClick: () => onClickDelistDomainItem(item),
    },
  ];

  return (
    <div>
      <Menu items={menuItems} />
    </div>
  );
};

export default DomainItemDetailAction;
